
  export const GET_ALL_ELECTRICITY_TRANSACTION_API = "/electricity/transactions/all"
  export const GET_SINGLE_TRANSACTION = "/electricity/transactions/single/"
  export const GET_ELECTRICITY_REPORT_API = "/electricity/transactions/report"
  export const RAISE_TICKET_API = "/ticket/start/"
  export const ARCHIOVE_TICKET_API = "/ticket/archive/"